// @flow

import * as React from "react";

import NumberInput from "../NumberInput";

type AreaInputProps = {};

const AreaInput = (props: AreaInputProps) => (
  <NumberInput
    {...props}
    sideSymbol={() => (
      <span>
        m<sup>2</sup>
      </span>
    )}
  />
);

export default AreaInput;
